<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/arrematantes/services'
  import RelatorioLoading from '../../leiloes/components/_RelatorioLoading'
  import moment from 'moment'

  export default {
    components: {RelatorioLoading},
    nome: 'relatorio-arrematante-basico',
    directives: {mask},
    data () {
      let Status = [
        {name: 'Incompleto', value: 0, class: 'text-warning'},
        {name: 'Completo', value: 1, class: 'text-success'},
        {name: 'Não Aprovado', value: 98, class: 'text-primary'},
        {name: 'Bloqueado', value: 99, class: 'text-danger'}
      ]
      return {
        page: 1,
        pages: 0,
        limit: 100,
        isLoading: false,
        result: null,
        filterKey: '',
        sortKey: '',
        statusArrematante: Status,
        filtro: {
          tipoPessoa: '',
          situacao: Status.map(a => a.value),
          data1: moment(new Date()).format('DD/MM/YYYY'),
          data2: moment(new Date()).endOf('month').format('DD/MM/YYYY')
        },
        tiposPessoa: [
          {label: 'Qualquer', value: '', class: 'btn-default'},
          {label: 'Física', value: 1, class: 'btn-default'},
          {label: 'Jurídica', value: 2, class: 'btn-default'}
        ],
        situacaoCadastro: [
          {label: 'Qualquer', value: '', class: 'btn-default'},
          {label: 'Completo', value: 1, class: 'btn-success'},
          {label: 'Incompleto', value: 0, class: 'btn-warning'},
          {label: 'Não Aprovado', value: 98, class: 'btn-primary'},
          {label: 'Bloqueado', value: 99, class: 'btn-danger'}
        ],
        showFiltros: false,
        mostrarCadastros: false
      }
    },
    computed: {
      filteredData: function () {
        // let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let filtrosFixos = this.filtro
        // let order = this.sortOrders[sortKey] || 1
        let data = this.result.resumo.arrematantes
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }

        // Situação
        data = data.filter(function (row) {
          return filtrosFixos.situacao.some(el => el === row.status)
        })

        this.pages = Math.ceil(data.length / this.limit)
        let index = (this.page * this.limit) - this.limit
        let end = (this.page * this.limit)
        console.log(this.pages, index, end, this.limit)
        return data.slice(index, end)
      },
      data1 () {
        if (!this.result.resumo.data1) {
          return
        }
        let data = this.result.resumo.data1.split('-')
        return `${data[2]}/${data[1]}/${data[0]}`
      },
      data2 () {
        if (!this.result.resumo.data2) {
          return
        }
        let data = this.result.resumo.data2.split('-')
        return `${data[2]}/${data[1]}/${data[0]}`
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.geraRelatorio()
    },
    deactivated () {
    },
    watch: {},
    methods: {
      geraRelatorio () {
        this.isLoading = true
        let data1 = this.filtro.data1.split('/')
        data1 = data1[2] + '-' + data1[1] + '-' + data1[0]
        let data2 = this.filtro.data2.split('/')
        data2 = data2[2] + '-' + data2[1] + '-' + data2[0]
        service.relatorioBasico({
          data1,
          data2
        })
          .then((response) => {
            this.isLoading = false
            this.result = response.data
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },
      getStatusArrematante (s) {
        return this.statusArrematante.filter((r) => {
          return r.value === s
        })[0]
      }
    }
  }
</script>

<template>
  <div class="r-container" :class="{'is-loading': isLoading}">
    <relatorio-loading v-if="isLoading"></relatorio-loading>
    <transition name="slide">
      <div v-if="!isLoading" class="content-transition relatorio-print" id="container-printer">
        <div class="hidden-print">
          <div class="text-center m-t m-b-n">
            <h3 @click="showFiltros = !showFiltros" class="btn m-t-none"><span class="btn btn-default btn-xs m-r-xs">{{ !showFiltros ? '+' : '-' }}</span>Filtros
            </h3>
          </div>
          <div class="r-table" v-show="showFiltros">
            <div class="r-table-content">
              <div class="m-t">
                <div class="m-b">
                  <div>Data:</div>
                  Data Início: <input v-model="filtro.data1" class="input-sm" v-mask="'##/##/####'"/> Data Fim: <input
                  class="input-sm" v-model="filtro.data2" v-mask="'##/##/####'"/>
                </div>
                <div class="m-b">
                  <div>Tipo de Pessoa:</div>
                  <u-button-group v-model="filtro.tipoPessoa" :options="tiposPessoa"></u-button-group>
                </div>

                <div class="m-b">
                  <div>Situação do Cadastro:</div>
                  <u-button-group v-model="filtro.situacao" :options="situacaoCadastro"></u-button-group>
                </div>

                <div class="m-t-lg">
                  <button class="btn btn-default" @click="geraRelatorio" @keyup.enter="geraRelatorio">Gerar Relatório
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="hidden-print">
          <h2 class="text-center text-uppercase font-bold m-b-none">Relatório de Arrematantes</h2>
        </div>

        <div v-if="result !== null">
          <div class="printer-page pos-rlt">
            <div class="r-table">
              <div class="r-table-content">
                <table class="table table-bordered r-table-min">
                  <tbody>
                  <tr>
                    <td>Período:</td>
                    <td><strong>{{data1}} a {{data2}}</strong></td>
                  </tr>
                  <tr>
                    <td>Total de cadastros</td>
                    <td><strong>{{result.resumo.total}}</strong> ({{result.resumo.totalPF}} PF /
                      {{result.resumo.totalPJ}} PJ)
                    </td>
                  </tr>
                  <tr>
                    <td>Cadastros Completos:</td>
                    <td><strong>{{result.resumo.totalCompletos}}</strong></td>
                  </tr>
                  <tr>
                    <td>Cadastros Incompletos:</td>
                    <td><strong>{{result.resumo.totalIncompletos}}</strong></td>
                  </tr>
                  <tr>
                    <td>Cadastros Não Aprovados:</td>
                    <td><strong>{{result.resumo.totalNaoAprovados}}</strong></td>
                  </tr>
                  <tr>
                    <td>Cadastros Bloqueados:</td>
                    <td><strong>{{result.resumo.totalBloqueados}}</strong></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="!mostrarCadastros" class="text-center hidden-print"><a class="btn btn-success center"
                                                                            @click="mostrarCadastros = true">Visualizar
            Cadastros</a></div>

          <div v-if="pages > 1 && mostrarCadastros" class="alert alert-warning text-center m-b hidden-print">Este relatório é muito grande e teve que ser dividido em {{pages}} páginas</div>
          <div v-if="pages > 1 && mostrarCadastros" class="text-center">
            Página: <select v-model="page">
              <option v-for="n in pages" :value="n">{{n}}</option>
            </select>
          </div>
          <div class="r-table relatorio-a-basico" v-if="mostrarCadastros">
            <div class="r-table-content">
              <div v-for="(arrematante, key) in filteredData" class="pos-rlt b-b m-b-lg">
                <table class="w-full table table-bordered m-b-none">
                  <tbody>
                  <tr>
                    <td>Situação</td>
                    <td><strong :class="getStatusArrematante(arrematante.status).class">{{getStatusArrematante(arrematante.status).name}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>Arrematante</td>
                    <td colspan="3" class="font-bold">{{ arrematante.pessoa.nome }}
                      ({{ arrematante.apelido }}) #A{{ arrematante.id }}-P{{
                      arrematante.pessoa.id }}

                      <!--<table class="w-full">
                        <tr>
                          <td>CPF</td>
                          <td>{{ arrematante.pessoa.pfCpf }}</td>
                        </tr>
                      </table>-->


                    </td>
                  </tr>
                  <tr v-if="arrematante.pessoa.tipo === 1">
                    <td>Tratamento</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfTratamento }}</td>
                    <td>Sexo</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfSexo === 1 ? 'M' : 'F' }}</td>
                  </tr>
                  <tr v-if="arrematante.pessoa.tipo === 1">
                    <td>CPF</td>
                    <td class="font-bold"><span v-if="arrematante.pessoa.pfCpf">{{ arrematante.pessoa.pfCpf | formataCpf }}</span><span
                      v-else>SEM CPF</span></td>
                    <td>RG</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfRg }} {{
                      arrematante.pessoa.pfRgOrgaoEmissor }}
                    </td>
                  </tr>
                  <tr v-if="arrematante.pessoa.tipo === 1">
                    <td>Data de Nascimento</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfDataNascimento ?
                      moment(arrematante.pessoa.pfDataNascimento.date).format('L') : '-' }}
                    </td>
                    <td>Estado Civil</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfEstadoCivilString }}</td>
                  </tr>
                  <tr
                    v-if="arrematante.pessoa.tipo === 1 && (arrematante.pessoa.pfFiliacaoNomePai || arrematante.pessoa.pfFiliacaoNomeMae)">
                    <td>Nome do Pai</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfFiliacaoNomePai }}</td>
                    <td>Nome da Mãe</td>
                    <td class="font-bold">{{ arrematante.pessoa.pfFiliacaoNomeMae }}</td>
                  </tr>
                  <tr v-if="arrematante.pessoa.tipo === 2">
                    <td>Razão Social</td>
                    <td class="font-bold">{{ arrematante.pessoa.pjRazaoSocial ||
                      arrematante.pessoa.nome }}
                    </td>
                    <td>Nome Fantasia</td>
                    <td class="font-bold">{{ arrematante.pessoa.pjNomeFantasia }}</td>
                  </tr>
                  <tr v-if="arrematante.pessoa.tipo === 2">
                    <td>CNPJ</td>
                    <td class="font-bold">{{ arrematante.pessoa.pjCnpj }}</td>
                    <td>Inscrição Estadual</td>
                    <td class="font-bold">{{ arrematante.pessoa.pjInscricaoEstadual }}</td>
                  </tr>
                  <tr v-if="arrematante.pessoa.tipo === 2">
                    <td>Responsável</td>
                    <td class="font-bold">{{ arrematante.pjProprietarioNome }}</td>
                    <td>CPF</td>
                    <td class="font-bold"><span v-if="arrematante.pjProprietarioCpf">{{ arrematante.pjProprietarioCpf | formataCpf }}</span><span
                      v-else>SEM CPF DO RESPONSÁVEL</span></td>
                  </tr>
                  <tr>
                    <td>IP Cadastro</td>
                    <td class="font-bold">{{ arrematante.pessoa.ipCadastro }}</td>
                    <td>Observação</td>
                    <td class="font-bold">{{ arrematante.pessoa.observacao }}</td>
                  </tr>
                  </tbody>
                </table>

                <!-- ENDEREÇOS -->
                <div class="tab-border no-border-top">
                  <table class="w-full table-arremate">
                    <thead>
                    <tr>
                      <th>
                        Endereço
                      </th>
                      <th style="width: 18%; white-space: nowrap">
                        Cidade
                      </th>
                      <th style="width: 18%; white-space: nowrap">
                        UF
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="endereco in arrematante.pessoa.enderecos">
                      <td>
                        {{ endereco.logradouro }}, {{ endereco.numero }} {{ endereco.complemento }}, {{ endereco.bairro
                        }}, {{ endereco.cep | formataCep }}
                      </td>
                      <td>
                        {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}
                      </td>
                      <td>
                        {{ endereco.municipio && endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- CONTATOS -->
                <div class="tab-border no-border-top">
                  <table class="w-full table-arremate">
                    <thead>
                    <tr>
                      <th>
                        Telefones
                      </th>
                      <th style="width: 50%; white-space: nowrap">
                        Emails
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                    <span v-for="telefone in arrematante.pessoa.telefones">
                        {{ telefone.telefone | formataTelefone }},
                    </span>
                      </td>
                      <td>
                    <span v-for="email in arrematante.pessoa.emails">
                        {{ email.email }},
                    </span>
                      </td>
                    </tr>

                    </tbody>
                  </table>
                </div>

                <!-- TELEFONES -->
                <div class="tab-border no-border-top">
                  <table class="w-full table-arremate">
                    <tbody>
                    <tr>
                      <td>
                        <router-link tag="a" :to="{name: 'arrematantes.visualizar', params: {id: arrematante.id}}"
                                     class="text-info" target="_blank">
                          https://intranet.rogeriomenezes.com.br/#/website/arrematantes/1
                        </router-link>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="display: block; border-bottom: #000000 1px dashed; margin-top: 20px"></div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>

<style lang="scss">
  .relatorio-a-basico{
    font-size: 11px !important;
  }
</style>



// WEBPACK FOOTER //
// RelatorioBasico.vue?08522007